<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }" :title="title">
    <feather-icon
      :icon="params.data.projectState === 'DONE' ? 'flag-checkered' : 'circle'"
      :svg-classes="svgClasses"
    />
  </div>
</template>

<script>
export default {
  name: "CellRendererStatus",
  computed: {
    svgClasses() {
      let color =
        this.params.data.projectState === "INACTIVE"
          ? "text-danger"
          : "text-success";
      return `h-5 w-5 ${color} cursor-pointer`;
    },
    title() {
      if (this.params.data.projectState === "INACTIVE") {
        return "Inaktiv";
      } else if (this.params.data.projectState === "ACTIVE") {
        return "Aktiv";
      } else {
        return "Abgeschlossen";
      }
    }
  }
};
</script>
